import { Post } from "domain/infra/data/api";
import AuthConstants from "../../infra/data/authConstants"
import { UsuarioResponse } from "domain/types/usuario/usuarioResponse";
export class PerfilService {// extends ExemploService {
  constructor() {
    //super()
  }

  async AlterarPerfil(request: FormData): Promise<UsuarioResponse | Error> {
    return await Post(AuthConstants.apiAuth.auth.alterarPerfil, request)
  }
}
